import src from "IMAGE";
export default { src, width: 664, height: 200, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARklEQVR42jXLMQqAMAxG4cTkJwUliq6dPYDg5iQ9QHv/yzQd+uAbH1HEzBAR01DSUVo6q/FiNANwufsT3rz6d2/7D9U83g5nRAOR+63/sgAAAABJRU5ErkJggg=="};
